import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useT } from '../I18nContext';

/**
 * Help modal - D5c. Static reference content, ported from the
 * legacy template's #help-lightbox.
 *
 * Reuses the History-modal scrim styling for visual consistency.
 * Opened from the sidebar UserMenu's "Help" item.
 */
interface HelpModalProps {
  onClose: () => void;
}

export function HelpModal({ onClose }: HelpModalProps) {
  const t = useT();
  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if (e.key === 'Escape') onClose();
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      className="history-modal-scrim"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-label={t('help_modal.title')}
    >
      <div className="history-modal" onClick={(e) => e.stopPropagation()}>
        <header className="history-modal-header">
          <h2 className="history-modal-title">{t('help_modal.title')}</h2>
          <button
            type="button"
            className="history-modal-close"
            onClick={onClose}
            aria-label={t('common.close')}
          >
            <X size={18} />
          </button>
        </header>

        <div className="history-modal-body">
          <p className="help-modal-lede">{t('help_modal.lede')}</p>

          <ul className="help-modal-list">
            {/* Each tip is split into a bold opener + body so
                translators can flip word order without losing the
                rich-text emphasis. A leading space before the body
                separates it from the strong's trailing punctuation. */}
            <li>
              <strong>{t('help_modal.tip1_strong')}</strong> {t('help_modal.tip1_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip2_strong')}</strong> {t('help_modal.tip2_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip3_strong')}</strong> {t('help_modal.tip3_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip4_strong')}</strong> {t('help_modal.tip4_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip5_strong')}</strong> {t('help_modal.tip5_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip6_strong')}</strong> {t('help_modal.tip6_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip7_strong')}</strong> {t('help_modal.tip7_body')}
            </li>
            <li>
              <strong>{t('help_modal.tip8_strong')}</strong> {t('help_modal.tip8_body')}
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
